export const environment = {
  production: true,
  proxyBaseUrl: '/ciprs_proxy_ws_1_1_0/rest/v1/',
  criminalApplicationUrl: 'https://cis1.nccourts.org/ciprsweb/civilstyle/',
  estateBaseUrl: 'TBD',
  sessionTimeout: '',
  security: {
    client_id: '97ae1ed4-3e4c-4d8c-846f-260af888c7d9',
    redirect_uri: '/auth.html',
    client_certificate_auth_uri: 'https://cis1.nccourts.org:30443/aas/oauth/authorize',
    auth_uri: '/oauth/authorize',
    check_token_uri: '/oauth/v2/check_token_with_state',
    revoke_token_uri: '/oauth/revoke_token',
    }
};



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/environments/environment.ts